const SELENIUM_DISABLE_ONBOARDING_TOURS_KEY = 'selenium.disable.onboarding_tours';
const isDisabledViaLocalStorage = () => {
  try {
    return localStorage.getItem(SELENIUM_DISABLE_ONBOARDING_TOURS_KEY) === 'true';
  } catch (error) {
    return false;
  }
};
const isAcceptanceTest = () => {
  try {
    return document.cookie.includes('hs_selenium');
  } catch (error) {
    return false;
  }
};
export const shouldDisableOnboardingTour = () => {
  return isDisabledViaLocalStorage() || isAcceptanceTest();
};